import { ReactElement } from 'react';
import { CheckboxInputAccessible } from '@components';
import { useFormikContext, Field } from 'formik';
import { iInfringementExtensionFormValues } from '@services/InfringementExtensionService';

function InfringementExtStep9(): ReactElement {
  const { values }: { values: iInfringementExtensionFormValues } = useFormikContext();
  return (
    <>
      <div className="vfH2">Declaration</div>
      { values.isDebtorTypeIndividual && (
        <div>
          <p>I authorise Fines Victoria to disclose my personal information to the enforcement agencies that issued the fine(s), the Magistrates’ Court and any person whose evidence I rely on in support of this application.</p>
          <p>I understand that Fines Victoria may update its records with my contact details provided on this form, and that I may be contacted regarding my outstanding fines. </p>
          <p>I declare that the information supplied in this form, and any attachments to this form, are true and correct to the best of my knowledge. </p>
          <p>I understand that it is an offence under the <i>Fines Reform Act 2014</i> to intentionally provide false or misleading information in a written statement required in an infringement extension application to Fines Victoria. I understand that the offence carries a fine of more than $2000.</p>
        </div>
      )}
      { values.isDebtorTypeCompany && (
        <div>
          <p>I authorise Fines Victoria to disclose my personal information to the enforcement agencies that issued the fine(s), the Magistrates’ Court of Victoria and any person whose evidence the company relies on in support of this application.</p>
          <p>I understand that Fines Victoria may update its records with my contact details provided on this form, and that I may be contacted regarding the company’s outstanding fines.</p>
          <p>I declare that the information supplied in this form, and any attachments to this form, are true and correct to the best of my knowledge.</p>
          <p>I understand that it is an offence under the <i>Fines Reform Act 2014</i> to intentionally provide false or misleading information in a written statement required in an infringement extension application to Fines Victoria. I understand that the offence carries a fine of more than $2000.</p>
        </div>
      )}

      <Field component={CheckboxInputAccessible} name="declaration" title="I agree to the statements above" />
    </>
  );
}

export default InfringementExtStep9;
